import React from 'react'

export const ChartHeader = () => (
  <div className="max-w-screen font-regular bg-[#1F2937] px-4 py-1.5 font-MaisonNeueExtended text-white">
    <div className="mx-auto max-w-page">
      RWA Statistics on Provenance Blockchain
    </div>
  </div>
)
